export default __webpack_public_path__ + "static/media/sparkle.6b3ee43c.svg";